import React, { useCallback } from 'react';
import { runAnalytics } from '../../analytics/webAnalytics.js';
const withTaggingFieldClickHandler = (Component) => {
    const FieldWithTaggingClickHandler = ({ taggingLabel, journeyEvent, eventAction, journeyAction, journeyActionNarrative, onClick, isQA, linkValue, isOldJourney, journeyAddons, journeyTariff, ...rest }) => {
        const handleOnClick = useCallback((event) => {
            if (taggingLabel) {
                const [fieldName, qaAnswer] = taggingLabel.split(':');
                const analyticsValue = {
                    JourneyEvent: journeyEvent,
                    EventAction: eventAction,
                    EventNarrative: taggingLabel,
                    FieldName: taggingLabel,
                    LinkValue: linkValue,
                    JourneyAction: journeyAction,
                    JourneyActionNarrative: journeyActionNarrative,
                    ...(isQA && {
                        FieldName: fieldName,
                        QAQuestion: fieldName,
                        QAAnswer: qaAnswer,
                    }),
                    ...(isOldJourney && {
                        JourneyTariff: journeyTariff,
                        JourneyAddons: journeyAddons,
                    }),
                };
                runAnalytics((analytics) => {
                    analytics.events.send(analyticsValue);
                });
            }
            onClick?.(event);
        }, [
            onClick,
            taggingLabel,
            isQA,
            journeyActionNarrative,
            journeyAction,
            eventAction,
            journeyEvent,
            linkValue,
            isOldJourney,
            journeyAddons,
            journeyTariff,
        ]);
        return React.createElement(Component, { ...rest, onClick: handleOnClick });
    };
    return FieldWithTaggingClickHandler;
};
export default withTaggingFieldClickHandler;
//# sourceMappingURL=index.js.map